export default __webpack_public_path__ + "static/media/sidebar-spotlight.90634eea.svg";